
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11477',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11477",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.211",
  "data-fetching-client": "static-1.9454",
  "foundations-components": "static-1.7479",
  "foundations-components-legacy": "static-1.504",
  "foundations-theming": "static-1.4185",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7781",
  "hub-http-shared-msw-handlers": "static-1.9416",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11198",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6248",
  "marketplace-storefront-base": "static-1.11537",
  "quartz": "static-1.6692",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16417",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2638",
  "reporting-testing-lib": "static-1.8339",
  "settings-ui-lib": "static-1.12296",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6680",
  "ui-addon-i18n": "static-1.10908",
  "ui-addon-react-router-dom": "static-1.9324",
  "unified-auth": "static-1.170",
  "unified-auth-core-lib": "static-1.451",
  "usage-tracker": "static-1.7108",
  "usage-tracker-core": "static-1.6958",
  "customer-data-property-utils": "static-1.7847",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15332",
  "marketplace-ui-common": "static-1.18872",
  "property-management-iframe": "static-1.12215",
  "quartz-config": "static-1.470",
  "quartz-core": "static-1.5911",
  "quartz-routing": "static-1.122",
  "quick-fetch": "static-1.3711",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4408",
  "ts-schema": "static-1.3882",
  "ui-universal-auth": "static-1.8656",
  "UIComponents": "static-3.8145",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3206",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2969",
  "quartz-webpack": "static-1.2916",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3748",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4609",
  "foundations-theming-specialty": "static-1.1901",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9204",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5151",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1120",
  "ui-fonts": "static-1.460",
  "ui-images": "static-2.1085",
  "bend-plugin-foundations-theming": "static-1.2668",
  "foundations-theming-base": "static-1.3170",
  "stylex": "static-1.27",
  "HeadJS": "static-2.704",
  "hs-test-utils-bend-plugin": "static-1.2892",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4105",
  "ai-components-ui-library": "static-1.8282",
  "ai-rendering-library": "static-1.9225",
  "chirp-fetch": "static-1.1660",
  "connections-embed-lib": "static-1.590",
  "copilot-toolkit": "static-1.10457",
  "laboratory-lib": "static-3.6938",
  "marketplace-embed": "static-1.21410",
  "marketplace-ui-details": "static-1.8768",
  "marketplace-ui-reviews": "static-1.18828",
  "marketplace-ui-tracking": "static-1.13043",
  "sanitize-text": "static-1.7916",
  "ui-addon-video-player": "static-1.8472",
  "usage-tracker-multi": "static-1.5522",
  "usage-tracker-session-replay": "static-1.4794",
  "wootric-nps": "static-1.6758",
  "apollo-link-hub-http": "static-2.4424",
  "immer": "static-1.33",
  "immerable": "static-1.3930",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2381",
  "reporting-data": "static-1.66406",
  "cssUtils": "static-1.725",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11506",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9987",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10148",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7098",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17405",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4299",
  "foundations-components-test-utils": "static-1.4962",
  "quartz-i18n": "static-1.367",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3507",
  "customer-data-objects": "static-1.7419",
  "property-translator": "static-1.5189",
  "frontend-preferences-client": "static-1.7700",
  "hs-promise-utils": "static-1.5367",
  "hubspot-apollo-client": "static-1.4655",
  "integrations-error-boundary-lib": "static-1.12747",
  "integrations-tracking-lib": "static-1.5360",
  "native-integrations-shared-strings": "static-1.7564",
  "reselect": "static-2.16",
  "sanitize": "static-1.4250",
  "superstore": "static-1.4547",
  "ui-shepherd-react": "static-3.9920",
  "ai-settings-ui-library": "static-1.7374",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4455",
  "immutable-less": "static-1.4429",
  "marketplace-ui-client-types": "static-1.16279",
  "nav-meta": "static-1.28825",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10012",
  "ui-addon-upgrades": "static-9.17615",
  "inbound-db-properties-service-client": "static-1.3653",
  "property-management-common": "static-1.4502",
  "ui-addon-iframeable": "static-1.8817",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.367",
  "quartz-head": "static-1.357",
  "quartz-test": "static-1.367",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2921",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20209",
  "ContentUtils": "static-1.67549",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2261",
  "customer-data-filters-ui": "static-1.38797",
  "customer-data-objects-ui-components": "static-1.12780",
  "customer-data-reference-ui-components": "static-1.12917",
  "embedded-academy-lib": "static-1.13411",
  "ExportDialog": "static-6.10164",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40594",
  "reporting-snowflake": "static-1.55024",
  "reporting-ui-components": "static-2.63677",
  "reporting-visualizations": "static-1.58482",
  "ui-addon-teams": "static-1.21206",
  "magpie-lib": "static-1.5370",
  "magpie-types": "static-1.4830",
  "simple-logging-lib": "static-1.2826",
  "navigation-components": "static-1.17188",
  "ai-studio-lib": "static-1.10922",
  "developer-experience-shared-components": "static-1.10244",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7760",
  "ui-tool-access": "static-1.9919",
  "usage-based-billing-components-lib": "static-1.7941",
  "usage-tracker-anonymous": "static-1.5525",
  "usage-tracker-public": "static-1.6919",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3483",
  "reference-resolvers": "static-1.7936",
  "ui-extensibility-client-types": "static-1.3723",
  "hubspot-apollo-cache": "static-1.114",
  "universal-page-editor-lib": "static-1.2772",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2111",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4846",
  "purchase-motions-components": "static-1.5449",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4284",
  "batch-promise": "static-1.1326",
  "crm-component-utils": "static-1.38422",
  "crm-properties-common-lib": "static-1.5647",
  "framework-data-schema-resolvers": "static-1.6646",
  "reference-resolvers-lite": "static-1.7866",
  "navigation-messaging": "static-1.6515",
  "hubspotter-http-shared-msw-handlers": "static-1.9414",
  "cms-field-types": "static-1.4581",
  "content-icons-ui": "static-1.2146",
  "conversations-skeleton-state": "static-1.7025",
  "crm-message-bus": "static-1.42274",
  "customer-data-filters-ui-msw-helpers": "static-1.21231",
  "customer-data-ui-utilities": "static-1.9599",
  "FormUrlGenerator": "static-2.4506",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6551",
  "multi-account-reference-resolvers": "static-1.745",
  "onboarding-tours": "static-1.16224",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12978",
  "academy-common-lib": "static-1.12871",
  "content-assistance-lib": "static-1.7413",
  "dashboard-lib": "static-1.80524",
  "file-manager-components": "static-1.22815",
  "getting-started-shared-tasks": "static-1.17806",
  "hubspot-prosemirror": "static-1.17535",
  "hubspot-prosemirror-plugins": "static-1.17527",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19430",
  "share-with-third-party-component-lib": "static-1.8467",
  "ui-addon-draggable": "static-3.4541",
  "ui-asset-management-lib": "static-1.10675",
  "ui-business-units-lib": "static-1.8802",
  "user-context": "static-1.4870",
  "growth-payments-core": "static-1.24650",
  "reporting-plugins": "static-1.9950",
  "reporting-reports": "static-1.66084",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.502",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28806",
  "react-codemirror": "static-1.10402",
  "apps-service-types": "static-1.3655",
  "oauth-service-types": "static-1.4017",
  "onboarding-scopes": "static-1.6239",
  "onboarding-tours-client": "static-1.4438",
  "platform-infra-nav-components": "static-1.7471",
  "subscription-experience-data-types": "static-1.14555",
  "crm-record-cards-service-types": "static-1.3430",
  "location-customization-utils-lib": "static-1.8472",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4300",
  "nav-client-types": "static-1.2132",
  "purchase-motions-api": "static-1.5452",
  "signup-constants": "static-1.18338",
  "signup-ui-url-generator": "static-2.7841",
  "trials-service-types": "static-1.3701",
  "card-properties-lib": "static-1.43446",
  "crm-actions": "static-1.6072",
  "crm-cards-data": "static-1.1157",
  "crm-cards-sdk": "static-1.42835",
  "customer-data-properties": "static-1.50721",
  "customer-data-properties-shared-msw-handlers": "static-1.8743",
  "customer-data-tracking": "static-1.6657",
  "conditional-properties-service-client": "static-1.3602",
  "crm-pipelines-api-client-types": "static-1.3942",
  "multi-currency-client-types": "static-1.3496",
  "external-options-client-types": "static-1.3962",
  "react-dnd-compat": "static-1.4398",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5127",
  "growth-onboarding-confetti": "static-1.2846",
  "growth-onboarding-next-action-utils": "static-1.1271",
  "onboarding-tours-utils": "static-1.290",
  "ui-shepherd-tracker": "static-1.7301",
  "academy-service-client": "static-1.3458",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27875",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8161",
  "video-components-external": "static-1.10491",
  "video-data-lib": "static-1.34149",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8345",
  "payment-link-components": "static-1.22867",
  "ui-addon-emoji-picker": "static-1.9664",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6806",
  "data-token-picker": "static-1.16002",
  "FileManagerLib": "static-1.38455",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5020",
  "getting-started-shared-tasks-store": "static-1.16924",
  "campaign-roi-lib": "static-1.8188",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.167",
  "eligibility-engine-service-types": "static-1.2982",
  "crm_data": "static-4.91132",
  "crm-links": "static-1.6032",
  "customer-data-sidebar": "static-2.45343",
  "enrichment-properties-lib": "static-1.14898",
  "crm-fe-perf": "static-1.22682",
  "calling-global-api": "static-1.63566",
  "calling-internal-common": "static-1.31069",
  "calling-lifecycle-internal": "static-1.64948",
  "calling-lifecycle-messages": "static-1.57242",
  "commerce-products-lib": "static-1.8780",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.449",
  "inbounddb-objects-service-types": "static-1.4028",
  "meetings-icalendar-utils-lib": "static-1.409",
  "object-builder-ui-client": "static-1.47880",
  "pipeline-validation-client-types": "static-1.3764",
  "property-value-citations": "static-1.1335",
  "pulse": "static-1.281",
  "smart-property-lib": "static-1.5780",
  "tiered-pricing": "static-1.790",
  "ui-addon-form-validation": "static-1.10770",
  "growth-onboarding-feedback-components": "static-1.6361",
  "content-media-composition-data-lib": "static-1.11355",
  "content-media-compositions": "static-2.15362",
  "media-bridge-lib": "static-1.18524",
  "commerce-tours-lib": "static-1.5679",
  "growth-onboarding-reliability": "static-1.4864",
  "sales-checkout-service-client": "static-1.3454",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21268",
  "sales-email-signature-service-client": "static-1.3621",
  "audio-components": "static-1.5577",
  "FileManagerCore": "static-1.38314",
  "FileManagerImages": "static-1.35966",
  "video-components": "static-1.12494",
  "crm_universal": "static-1.21620",
  "customer-data-email": "static-1.17628",
  "calling-error-reporting": "static-1.31075",
  "card-payment-highlight-lib": "static-1.36428",
  "card-subscription-highlight-lib": "static-1.38786",
  "commerce-billing-lib": "static-1.18426",
  "commerce-contract-lib": "static-1.11063",
  "customer-data-content": "static-1.26831",
  "invoices-highlight-card-lib": "static-1.53925",
  "orders-highlight-card-lib": "static-1.20810",
  "products-highlight-card-lib": "static-1.17064",
  "project-storage": "static-1.4508",
  "quotes-highlight-card-lib": "static-1.71059",
  "breeze-intelligence-kit": "static-1.5285",
  "crm-source-interpretation-lib": "static-1.5104",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9499",
  "policy-lib": "static-1.6557",
  "shared-worker-versioning": "static-1.10812",
  "calling-usage-tracker": "static-1.6314",
  "voice-sms-access-library": "static-1.166",
  "products-iframe-lib": "static-1.7247",
  "products-ui-components-shared-msw-handlers": "static-1.9798",
  "directed-graph": "static-1.713",
  "event-emitter": "static-1.723",
  "react-tinymce": "static-1.54550",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9562",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53676",
  "tinymce-plugins": "static-1.56790",
  "tinymce-themes": "static-1.55646",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4310",
  "video-embed": "static-1.34983",
  "social-insights-client-types": "static-1.21265",
  "sequences-lib": "static-1.7650",
  "ui-gdpr-components": "static-1.10123",
  "commerce-shared-components-lib": "static-1.17850",
  "commerce-subscription-lib": "static-1.36363",
  "commerce-tools-ui-lib": "static-1.9729",
  "utility-belt": "static-1.2318",
  "payments-enrollment-embed-lib": "static-1.21908",
  "products-ui-components": "static-1.39299",
  "quotes-client-types": "static-1.37147",
  "quotes-ui-lib": "static-1.79778",
  "SalesContentIndexUI": "static-3.8864",
  "accounting-integrations-ui-components": "static-1.6686",
  "invoices-ui-lib": "static-1.53941",
  "commerce-products-api": "static-1.1920",
  "SafeStorage": "static-1.4180",
  "invoices-iframe-lib": "static-1.55999",
  "quotes-modal-lib": "static-1.101735",
  "calling-orchestration-schema": "static-1.34943",
  "sales-views-client-types": "static-1.4068",
  "hub-http-contrib": "static-1.2820",
  "interframe": "static-3.4567",
  "tinymce-data": "static-1.39761",
  "ui-addon-sales-email": "static-1.4989",
  "layout-dnd-components": "static-1.11986",
  "layout-dnd-utils": "static-1.10961",
  "ui-brand-identity-lib": "static-1.13741",
  "NamespacedHubStyle": "static-2.8874",
  "outpost": "static-1.3981",
  "sequences-client-types-lib": "static-1.7507",
  "customer-data-associations": "static-1.7111",
  "framework-data-table": "static-2.11353",
  "customer-data-rte": "static-1.32386",
  "cv-backend-services": "static-1.1490",
  "growth-onboarding-empty-states": "static-1.5327",
  "InboxConnectUtils": "static-4.14156",
  "payments-post-enroll-local-storage-lib": "static-1.4888",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7092",
  "commerce-permissions": "static-1.528",
  "commerce-tax-lib": "static-1.285",
  "property-description-translator": "static-1.3635",
  "FireAlarmUi": "static-1.4305",
  "sales-templates-service-types-lib": "static-1.3972",
  "commerce-analytics-service-client": "static-1.3442",
  "totals-ui-components": "static-1.22935",
  "ContentData": "static-1.67624",
  "layout-data-lib": "static-1.9286",
  "deal-intel-decorators": "static-1.1162",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27654",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3616",
  "advanced-menus-core": "static-1.14779",
  "advanced-menus-lib": "static-1.11759",
  "ui-memberships-settings-lib": "static-1.33359",
  "deal-intel-utils": "static-1.1166",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14778",
  "simple-menus-lib": "static-1.16295"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11477",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.211",
  "data-fetching-client": "/data-fetching-client/static-1.9454",
  "foundations-components": "/foundations-components/static-1.7479",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.504",
  "foundations-theming": "/foundations-theming/static-1.4185",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7781",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9416",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11198",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6248",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11537",
  "quartz": "/quartz/static-1.6692",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16417",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2638",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8339",
  "settings-ui-lib": "/settings-ui-lib/static-1.12296",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6680",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10908",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9324",
  "unified-auth": "/unified-auth/static-1.170",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.451",
  "usage-tracker": "/usage-tracker/static-1.7108",
  "usage-tracker-core": "/usage-tracker-core/static-1.6958",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7847",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15332",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18872",
  "property-management-iframe": "/property-management-iframe/static-1.12215",
  "quartz-config": "/quartz-config/static-1.470",
  "quartz-core": "/quartz-core/static-1.5911",
  "quartz-routing": "/quartz-routing/static-1.122",
  "quick-fetch": "/quick-fetch/static-1.3711",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4408",
  "ts-schema": "/ts-schema/static-1.3882",
  "ui-universal-auth": "/ui-universal-auth/static-1.8656",
  "UIComponents": "/UIComponents/static-3.8145",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3206",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2969",
  "quartz-webpack": "/quartz-webpack/static-1.2916",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3748",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4609",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1901",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9204",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5151",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1120",
  "ui-fonts": "/ui-fonts/static-1.460",
  "ui-images": "/ui-images/static-2.1085",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2668",
  "foundations-theming-base": "/foundations-theming-base/static-1.3170",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.704",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2892",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4105",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8282",
  "ai-rendering-library": "/ai-rendering-library/static-1.9225",
  "chirp-fetch": "/chirp-fetch/static-1.1660",
  "connections-embed-lib": "/connections-embed-lib/static-1.590",
  "copilot-toolkit": "/copilot-toolkit/static-1.10457",
  "laboratory-lib": "/laboratory-lib/static-3.6938",
  "marketplace-embed": "/marketplace-embed/static-1.21410",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8768",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18828",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13043",
  "sanitize-text": "/sanitize-text/static-1.7916",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8472",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5522",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4794",
  "wootric-nps": "/wootric-nps/static-1.6758",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4424",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3930",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2381",
  "reporting-data": "/reporting-data/static-1.66406",
  "cssUtils": "/cssUtils/static-1.725",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11506",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9987",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10148",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7098",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17405",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4299",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4962",
  "quartz-i18n": "/quartz-i18n/static-1.367",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3507",
  "customer-data-objects": "/customer-data-objects/static-1.7419",
  "property-translator": "/property-translator/static-1.5189",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7700",
  "hs-promise-utils": "/hs-promise-utils/static-1.5367",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4655",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12747",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5360",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7564",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4250",
  "superstore": "/superstore/static-1.4547",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9920",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7374",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4455",
  "immutable-less": "/immutable-less/static-1.4429",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16279",
  "nav-meta": "/nav-meta/static-1.28825",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10012",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17615",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3653",
  "property-management-common": "/property-management-common/static-1.4502",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8817",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.367",
  "quartz-head": "/quartz-head/static-1.357",
  "quartz-test": "/quartz-test/static-1.367",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2921",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20209",
  "ContentUtils": "/ContentUtils/static-1.67549",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2261",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38797",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12780",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12917",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13411",
  "ExportDialog": "/ExportDialog/static-6.10164",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40594",
  "reporting-snowflake": "/reporting-snowflake/static-1.55024",
  "reporting-ui-components": "/reporting-ui-components/static-2.63677",
  "reporting-visualizations": "/reporting-visualizations/static-1.58482",
  "ui-addon-teams": "/ui-addon-teams/static-1.21206",
  "magpie-lib": "/magpie-lib/static-1.5370",
  "magpie-types": "/magpie-types/static-1.4830",
  "simple-logging-lib": "/simple-logging-lib/static-1.2826",
  "navigation-components": "/navigation-components/static-1.17188",
  "ai-studio-lib": "/ai-studio-lib/static-1.10922",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10244",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7760",
  "ui-tool-access": "/ui-tool-access/static-1.9919",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7941",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5525",
  "usage-tracker-public": "/usage-tracker-public/static-1.6919",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3483",
  "reference-resolvers": "/reference-resolvers/static-1.7936",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3723",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.114",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2772",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2111",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4846",
  "purchase-motions-components": "/purchase-motions-components/static-1.5449",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4284",
  "batch-promise": "/batch-promise/static-1.1326",
  "crm-component-utils": "/crm-component-utils/static-1.38422",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5647",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6646",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7866",
  "navigation-messaging": "/navigation-messaging/static-1.6515",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9414",
  "cms-field-types": "/cms-field-types/static-1.4581",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7025",
  "crm-message-bus": "/crm-message-bus/static-1.42274",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21231",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9599",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4506",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6551",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.745",
  "onboarding-tours": "/onboarding-tours/static-1.16224",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12978",
  "academy-common-lib": "/academy-common-lib/static-1.12871",
  "content-assistance-lib": "/content-assistance-lib/static-1.7413",
  "dashboard-lib": "/dashboard-lib/static-1.80524",
  "file-manager-components": "/file-manager-components/static-1.22815",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17535",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17527",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19430",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8467",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4541",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10675",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8802",
  "user-context": "/user-context/static-1.4870",
  "growth-payments-core": "/growth-payments-core/static-1.24650",
  "reporting-plugins": "/reporting-plugins/static-1.9950",
  "reporting-reports": "/reporting-reports/static-1.66084",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.502",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28806",
  "react-codemirror": "/react-codemirror/static-1.10402",
  "apps-service-types": "/apps-service-types/static-1.3655",
  "oauth-service-types": "/oauth-service-types/static-1.4017",
  "onboarding-scopes": "/onboarding-scopes/static-1.6239",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4438",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7471",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14555",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3430",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8472",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4300",
  "nav-client-types": "/nav-client-types/static-1.2132",
  "purchase-motions-api": "/purchase-motions-api/static-1.5452",
  "signup-constants": "/signup-constants/static-1.18338",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7841",
  "trials-service-types": "/trials-service-types/static-1.3701",
  "card-properties-lib": "/card-properties-lib/static-1.43446",
  "crm-actions": "/crm-actions/static-1.6072",
  "crm-cards-data": "/crm-cards-data/static-1.1157",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42835",
  "customer-data-properties": "/customer-data-properties/static-1.50721",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8743",
  "customer-data-tracking": "/customer-data-tracking/static-1.6657",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3602",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3942",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3496",
  "external-options-client-types": "/external-options-client-types/static-1.3962",
  "react-dnd-compat": "/react-dnd-compat/static-1.4398",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5127",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2846",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1271",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.290",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7301",
  "academy-service-client": "/academy-service-client/static-1.3458",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27875",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8161",
  "video-components-external": "/video-components-external/static-1.10491",
  "video-data-lib": "/video-data-lib/static-1.34149",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8345",
  "payment-link-components": "/payment-link-components/static-1.22867",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9664",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6806",
  "data-token-picker": "/data-token-picker/static-1.16002",
  "FileManagerLib": "/FileManagerLib/static-1.38455",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5020",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16924",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8188",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.167",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2982",
  "crm_data": "/crm_data/static-4.91132",
  "crm-links": "/crm-links/static-1.6032",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45343",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14898",
  "crm-fe-perf": "/crm-fe-perf/static-1.22682",
  "calling-global-api": "/calling-global-api/static-1.63566",
  "calling-internal-common": "/calling-internal-common/static-1.31069",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64948",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57242",
  "commerce-products-lib": "/commerce-products-lib/static-1.8780",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.449",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4028",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.409",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47880",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3764",
  "property-value-citations": "/property-value-citations/static-1.1335",
  "pulse": "/pulse/static-1.281",
  "smart-property-lib": "/smart-property-lib/static-1.5780",
  "tiered-pricing": "/tiered-pricing/static-1.790",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10770",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6361",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11355",
  "content-media-compositions": "/content-media-compositions/static-2.15362",
  "media-bridge-lib": "/media-bridge-lib/static-1.18524",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5679",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4864",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3454",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21268",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3621",
  "audio-components": "/audio-components/static-1.5577",
  "FileManagerCore": "/FileManagerCore/static-1.38314",
  "FileManagerImages": "/FileManagerImages/static-1.35966",
  "video-components": "/video-components/static-1.12494",
  "crm_universal": "/crm_universal/static-1.21620",
  "customer-data-email": "/customer-data-email/static-1.17628",
  "calling-error-reporting": "/calling-error-reporting/static-1.31075",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36428",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38786",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18426",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11063",
  "customer-data-content": "/customer-data-content/static-1.26831",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53925",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20810",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17064",
  "project-storage": "/project-storage/static-1.4508",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71059",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5285",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5104",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9499",
  "policy-lib": "/policy-lib/static-1.6557",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10812",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6314",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.166",
  "products-iframe-lib": "/products-iframe-lib/static-1.7247",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9798",
  "directed-graph": "/directed-graph/static-1.713",
  "event-emitter": "/event-emitter/static-1.723",
  "react-tinymce": "/react-tinymce/static-1.54550",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9562",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53676",
  "tinymce-plugins": "/tinymce-plugins/static-1.56790",
  "tinymce-themes": "/tinymce-themes/static-1.55646",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4310",
  "video-embed": "/video-embed/static-1.34983",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "sequences-lib": "/sequences-lib/static-1.7650",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10123",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17850",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36363",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9729",
  "utility-belt": "/utility-belt/static-1.2318",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21908",
  "products-ui-components": "/products-ui-components/static-1.39299",
  "quotes-client-types": "/quotes-client-types/static-1.37147",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79778",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8864",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6686",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53941",
  "commerce-products-api": "/commerce-products-api/static-1.1920",
  "SafeStorage": "/SafeStorage/static-1.4180",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55999",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101735",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34943",
  "sales-views-client-types": "/sales-views-client-types/static-1.4068",
  "hub-http-contrib": "/hub-http-contrib/static-1.2820",
  "interframe": "/interframe/static-3.4567",
  "tinymce-data": "/tinymce-data/static-1.39761",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4989",
  "layout-dnd-components": "/layout-dnd-components/static-1.11986",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10961",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13741",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8874",
  "outpost": "/outpost/static-1.3981",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7507",
  "customer-data-associations": "/customer-data-associations/static-1.7111",
  "framework-data-table": "/framework-data-table/static-2.11353",
  "customer-data-rte": "/customer-data-rte/static-1.32386",
  "cv-backend-services": "/cv-backend-services/static-1.1490",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5327",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14156",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4888",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7092",
  "commerce-permissions": "/commerce-permissions/static-1.528",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.285",
  "property-description-translator": "/property-description-translator/static-1.3635",
  "FireAlarmUi": "/FireAlarmUi/static-1.4305",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3972",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3442",
  "totals-ui-components": "/totals-ui-components/static-1.22935",
  "ContentData": "/ContentData/static-1.67624",
  "layout-data-lib": "/layout-data-lib/static-1.9286",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1162",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27654",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3616",
  "advanced-menus-core": "/advanced-menus-core/static-1.14779",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11759",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33359",
  "deal-intel-utils": "/deal-intel-utils/static-1.1166",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14778",
  "simple-menus-lib": "/simple-menus-lib/static-1.16295"
}
};
